import el from "@cypherpotato/el";
import { formatNumber, formatTokenCount } from "../ui/format";

export function TokenLabel(count) {
    return el("span.token-count", formatTokenCount(count), { title: formatNumber(count) });
}